/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import ReactSelect, { Option } from 'react-select'

import globalNotification from 'live/services/global-notification'
import i18n from 'live/services/i18n'

// import i18n from 'live/services/i18n'

import {
    IInfoPresenter,
    PresenterProps,
    OnUpdateEvent
} from 'plugin-aeapps-resources-manager/shared/api/IInfoPresenter'
import { FilteredSearch } from 'plugin-channelmanager/generic/FilteredSearch/FilteredSearch'
import { CustomList } from 'plugin-generic-components/shared/components/components'

import { listChannels } from '../services/channels'
import { ConsoleModal, IUpdatedExpression } from './components/ConsoleModal/ConsoleModal'
import { BottomRowContainer, MappedChannelsComponentContainer } from './styles'


interface IConsoleObject {
    chart: boolean
    defaultReducer: string
    description: string
    expression: string
    follow: boolean
    preload: boolean
    reducer: string
    reducerType: string
    span: string
}

interface IMappedChannelsObjectList {
    id: string
    idx: number
    name: string | JSX.Element
    channelType: string
    sourceType: string
    sourceSetup: JSX.Element
}

interface IMappedChannelsDto {
    channelId: string
    sourceId: string
    sourceConfig: ISourceConfig
    isQueryEnabled: boolean
}

interface ISourceConfig {
    provider: string
    expression: string
}

export interface IAssignChannel {
    generalAssetId: number
    mappedChannelsDto: IMappedChannelsDto[]
}

const defaultInfo: IAssignChannel = {
    generalAssetId: null,
    mappedChannelsDto: []
}

export const MappedChannelsComponent: React.FC<PresenterProps<IAssignChannel>> = ({
    editMode,
    info = defaultInfo,
    onChanged
    // requestError
}) => {
    const [channels, setChannels] = useState<IChannel[]>([])
    const [assetChannels, setAssetChannels] = useState<IChannel[]>([])
    const [searchTerm, setSearchTerm] = useState('')
    const [channelToAdd, setChannelToAdd] = useState<IChannel>()
    const [showConsoleModal, setShowConsoleModal] = useState(false)
    const [selectedMappedChannel, setSelectedMappedChannel] = useState<IMappedChannelsDto>(null)
    // const [isValid, setIsValid] = useState<boolean>()

    const handleGetChannels = async (): Promise<void> => {
        try {
            if (info.generalAssetId && info.mappedChannelsDto) {
                const data = await listChannels()
                setChannels(data)
                console.log(
                    data.filter(channel => info.mappedChannelsDto.map(dto => dto.channelId).includes(channel.id))
                )
                setAssetChannels(
                    data.filter(channel => info.mappedChannelsDto.map(dto => dto.channelId).includes(channel.id))
                )
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleAssignNewChannel = (consoleObject?: IConsoleObject): void => {
        console.log('info', info)
        try {
            info.mappedChannelsDto.push({
                channelId: channelToAdd.id,
                sourceId: 'pipes',
                sourceConfig: {
                    provider: 'pipes',
                    expression: consoleObject?.expression ?? ''
                },
                isQueryEnabled: true
            })

            setAssetChannels(old => [...old, channelToAdd])

            setSelectedMappedChannel(info.mappedChannelsDto.find(mc => mc.channelId === channelToAdd.id))

            setChannelToAdd(null)
            setShowConsoleModal(true)
        } catch (error) {
            console.log('error', error)
        }
    }

    const handleEditMappedChannel = (e: React.FormEvent<HTMLButtonElement>, id: string): void => {
        try {
            e.preventDefault()

            setShowConsoleModal(true)

            setSelectedMappedChannel(info.mappedChannelsDto.find(mc => mc.channelId === id))
        } catch (error) {
            console.log(error)
        }
    }

    const handleUpdateExpression = (e: IUpdatedExpression): void => {
        const index = info.mappedChannelsDto.indexOf(selectedMappedChannel)
        if (index !== -1) {
            info.mappedChannelsDto[index].sourceConfig = {
                ...info.mappedChannelsDto[index].sourceConfig,
                expression: e.expression
            }
            info.mappedChannelsDto[index].isQueryEnabled = true
        }

        if (!e.expression || e.expression.trim().length === 0) {
            globalNotification.error('There is at least one channel without an expression')
        }
    }

    const handleDeleteChannel = (idx: string): void => {
        // info.mappedChannelsDto.slice(idx)
        info.mappedChannelsDto = info.mappedChannelsDto.filter(mc => mc.channelId !== idx)
        setAssetChannels(old => old.filter(mc => mc.id !== idx))
        handleValidate()
    }

    const handleValidate = (): void => {
        if (info.mappedChannelsDto && info.generalAssetId) {
            let isValid = info.mappedChannelsDto?.length > 0
            if (isValid) {
                info.mappedChannelsDto?.forEach(mc => {
                    if (!mc.sourceConfig.expression || mc.sourceConfig.expression.trim().length === 0) {
                        isValid = false
                        globalNotification.error('There is at least one channel without an expression')
                    }
                })
            } else {
                globalNotification.error('Assign at least one channel')
            }

            onChanged({ infoNewState: info, validated: isValid })
        }
    }

    useEffect(() => {
        if (info.generalAssetId) {
            localStorage.setItem('generalAssetId', String(info.generalAssetId))
        }

        if (localStorage.getItem('generalAssetId') && !info.generalAssetId) {
            info.generalAssetId = Number(localStorage.getItem('generalAssetId'))
            info.mappedChannelsDto = info.mappedChannelsDto ?? []
        }

        handleGetChannels()
        onChanged({ infoNewState: info, validated: false })
    }, [])

    useEffect(() => {
        handleValidate()
    }, [editMode])

    return (
        <MappedChannelsComponentContainer>
            {assetChannels.length > 0 ? (
                <>
                    <FilteredSearch className="mapped-channels-search" onSearch={e => setSearchTerm(e)} />
                    <CustomList
                        className={editMode ? 'mapped-channels-list-edit-mode' : 'mapped-channels-list'}
                        list={assetChannels
                            .filter(
                                el =>
                                    el.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                    el.id?.toLowerCase().includes(searchTerm.toLowerCase())
                            )
                            .map<IMappedChannelsObjectList>((el, index) => ({
                                id: el.id,
                                idx: index,
                                name: editMode ? (
                                    <ReactSelect
                                        options={channels
                                            .filter(c => {
                                                return (
                                                    c.id === el.id ||
                                                    !info.mappedChannelsDto.map(mc => mc.channelId).includes(c.id)
                                                )
                                            })
                                            .map(op => ({ value: op.id, label: op.name }))}
                                        onChange={(obj: Option<string>) => {
                                            const targetChannel = assetChannels.find(mc => mc.id === obj.value)
                                            assetChannels[index] = targetChannel
                                            setAssetChannels([...assetChannels])
                                        }}
                                        value={el.id}
                                        clearable={false}
                                    />
                                ) : (
                                    el.name
                                ),
                                channelType: el.channelType?.name,
                                sourceType: el.sourceType ?? 'PIPES',
                                sourceSetup: (
                                    <button
                                        className={editMode ? 'source-setup-button' : 'source-setup-button disabled'}
                                        type="button"
                                        onClick={e => handleEditMappedChannel(e, el.id)}
                                    >
                                        {i18n('Edit Query')}
                                    </button>
                                )
                            }))}
                        columns={
                            editMode
                                ? [
                                      { title: 'Channel Name', sortable: true, listRef: 'name' },
                                      { title: 'ID', sortable: true, listRef: 'id' },
                                      { title: 'Type', sortable: true, listRef: 'channelType' },
                                      { title: 'Source Type', sortable: true, listRef: 'sourceType' },
                                      { title: 'Source Setup', sortable: false, listRef: 'sourceSetup' }
                                  ]
                                : [
                                      { title: 'Channel Name', sortable: true, listRef: 'name' },
                                      { title: 'ID', sortable: true, listRef: 'id' },
                                      { title: 'Type', sortable: true, listRef: 'channelType' },
                                      { title: 'Source Type', sortable: true, listRef: 'sourceType' }
                                  ]
                        }
                        sortDirection={'ASC'}
                        sortField={'visible'}
                        onSortClick={() => console.log('sort')}
                        configOptions={
                            editMode
                                ? [{ icon: 'far fa-trash-alt', onClickConfig: ({ id }) => handleDeleteChannel(id) }]
                                : []
                        }
                    />
                </>
            ) : (
                <>
                    <div className="no-channel-assigned">
                        {i18n('There are no channels assigned to this resource.')}
                    </div>
                </>
            )}

            {editMode ? (
                <BottomRowContainer>
                    <div className="new-channel-container">
                        <ReactSelect
                            className="select-channel"
                            placeholder={`${i18n('Select channel')}...`}
                            options={channels
                                .filter(c => !info.mappedChannelsDto?.map(mc => mc.channelId).includes(c.id))
                                .map(op => ({ value: op.id, label: op.name }))}
                            onChange={(obj: Option<string>) => {
                                const targetChannel = channels.find(mc => mc.id === obj.value)
                                setChannelToAdd(targetChannel)
                            }}
                            clearable={false}
                            value={channelToAdd?.id}
                        />
                    </div>
                    <button
                        type="button"
                        className="add-channel-button"
                        onClick={() => {
                            if (channelToAdd) {
                                handleAssignNewChannel()
                            } else {
                                globalNotification.error('Select a channel')
                            }
                        }}
                    >
                        <i className="fas fa-plus" />
                        &nbsp;{i18n('Add Channel')}
                    </button>
                </BottomRowContainer>
            ) : (
                <></>
            )}
            {/* <p> Edit mode says if is in Edit Mode: {editMode.toString()} </p> */}
            {/* <div>The form information will be in info: {info} </div> */}
            {/* <div>if some error on save you will receive the Request Error: {requestError}</div> */}
            <div>
                <ConsoleModal
                    expression={selectedMappedChannel?.sourceConfig?.expression ?? ''}
                    show={showConsoleModal}
                    onUpdate={e => {
                        handleUpdateExpression(e)
                    }}
                    onClose={() => {
                        handleValidate()
                        setShowConsoleModal(false)
                    }}
                />
            </div>
        </MappedChannelsComponentContainer>
    )
}

export const mappedChannelsPresenter: IInfoPresenter<IAssignChannel> = {
    presenterCode: 'MappedChannels',
    title: 'Mapped Channels',
    group: 'Channels',
    order: 90,
    component: MappedChannelsComponent
}
